const ourclients = [
  { label: 'Bảo Minh', image: '/images/partner/1.png' },
  { label: 'Ford', image: '/images/partner/2.png' },
  { label: 'Kingsmen', image: '/images/partner/3.png' },
  { label: 'BIDV', image: '/images/partner/4.png' },
  { label: 'Manulife', image: '/images/partner/5.png' },
  { label: 'Thaco', image: '/images/partner/6.png' },
];

export default ourclients;
